import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ManifestService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  switchManifest(url: string) {
    let link = this.document.getElementById('app-dyn-man') as HTMLLinkElement;

    if (link) {
      link.href = url;
    }
  }

  switchTheme(theme: string) {
    let link = this.document.getElementById('app-dyn-man') as HTMLLinkElement;

    if (link) {
      link.href = theme;
    }
  }
}
